const ALLOWED_IMAGE_TYPES = "image/png, image/jpeg";
const ALLOWED_VIDEO_TYPES = "video/mp4, video/quicktime";
const ALLOWED_DOCUMENT_TYPES = "application/pdf";

export const ALLOWED_FILE_TYPES = {
  IMAGE: ALLOWED_IMAGE_TYPES,
  VIDEO: ALLOWED_VIDEO_TYPES,
  DOCUMENT: ALLOWED_DOCUMENT_TYPES,
};
